import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const RepresentativesPage = lazyWithRetry(() => import("@/features/representatives/pages/RepresentativesPage"));

const representativesRoutes: RouteConfig[] = [
  {
    path: "/trombinoscope",
    element: <RepresentativesPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default representativesRoutes;
